import { render } from "./ServiceAll.vue?vue&type=template&id=cfb5605a&scoped=true"
import script from "./ServiceAll.vue?vue&type=script&lang=js"
export * from "./ServiceAll.vue?vue&type=script&lang=js"

import "./ServiceAll.vue?vue&type=style&index=0&id=cfb5605a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cfb5605a"

export default script